
import { useContext } from "react";
import { AuthContext } from "./useAuthContext";

export const useAuth = () => {
  return useContext(AuthContext);
};

// Re-export the AuthProvider for convenience
export { AuthProvider } from "./useAuthContext";
